export const BRAND_NAME = "DealDraft";
